import "./CodeStatusKPI.css";

import { CodeCharacteristics } from "../../../../models";
import { GenericTooltip } from "../../../forms";
import { Divider } from "../../Divider";
import { useCodeStatusKPI } from "./useCodeStatusKPI";

interface CodeStatusKPIProps {
  codeCharacteristics: CodeCharacteristics;
  isProjectPage?: boolean;
}

const MAX_COUNT = 10;
export const CodeStatusKPI = ({ codeCharacteristics, isProjectPage = false }: CodeStatusKPIProps): JSX.Element => {
  const { codeCharacteristicsArray, codeCharacteristicsCount } = useCodeStatusKPI(codeCharacteristics);
  return (
    <div className={`CodeStatusContainer ${isProjectPage ? "ProjectPage" : ""}`}>
      <h2>Status</h2>
      <div className="CodeStatusTextArea">
        <h3>{codeCharacteristicsCount === MAX_COUNT ? "Established" : "Emerging"}</h3>
        <p className="body3">{codeCharacteristicsCount}/10 core carbon principles published</p>
      </div>
      <div className="CodeStatusGraphArea">
        <div className={`CodeStatusGraph ${codeCharacteristicsCount === MAX_COUNT ? "Established" : "Emerging"}`}>
          {codeCharacteristicsArray?.map((codeCharacteristic) => {
            return (
              <GenericTooltip
                key={codeCharacteristic.characteristicType}
                placement="bottomLeft"
                content={
                  <div className="CodeStatusTooltipContainer">
                    <p className="body3">{codeCharacteristic.characteristicType}</p>
                  </div>
                }
              >
                <div
                  className="GraphBar"
                  style={
                    codeCharacteristic.characteristicValue?.met && codeCharacteristicsCount < MAX_COUNT
                      ? {
                          backgroundColor: "var(--color-grey-300)",
                        }
                      : {}
                  }
                />
              </GenericTooltip>
            );
          })}
        </div>
        <Divider type="horizontal" />
        <div className="CodeStatusGraphLabelArea">
          <p className="body3">Emerging</p>
          <p className="body3">Established</p>
        </div>
      </div>
    </div>
  );
};
